import ANIMATION_TYPES from '../../../constants/animationTypes'

export default function SlideHOC (WrappedComponent) {
  return class Slide extends WrappedComponent {
    // !!! Wrapped component must have defineAnimations() method
    componentDidMount () {
      this.defineAnimations()
      this.animate(this.props.animation)
    }

    componentWillReceiveProps (nextProps) {
      this.animate(nextProps.animation)
    }

    currentAnimation = null
    currentAnimationProgress = 0
    currentAnimationType = ANIMATION_TYPES.NONE

    animate (animation) {
      if ((animation === this.currentAnimationType) || (animation === ANIMATION_TYPES.NONE)) return

      if (animation.hasOwnProperty('progress')) { // set animation state w/progress, emitted by onSwiping
        if (this.currentAnimation) this.currentAnimation.pause()

        if (animation.type === ANIMATION_TYPES.IN) {
          this.currentAnimation = this.inAnimation
        } else if (animation.type === ANIMATION_TYPES.IN_REVERSED) {
          this.currentAnimation = this.inReversedAnimation
        } else if (animation.type === ANIMATION_TYPES.OUT) {
          this.currentAnimation = this.outAnimation
        } else if (animation.type === ANIMATION_TYPES.OUT_REVERSED) {
          this.currentAnimation = this.outReversedAnimation
        }

        if (this.currentAnimationProgress === 0) {
          this.currentAnimation.progress(0)
        }

        this.currentAnimationProgress = animation.progress

        this.currentAnimation
          .progress(animation.progress)
          .pause()
      } else { // set animation state w/o progress
        // console.log(
        //   `slide${this.props.slideNum} animation:`,
        //   this.currentAnimationType,
        //   animation,
        //   this.currentAnimation && this.currentAnimation.progress(),
        // )

        if (this.currentAnimationProgress !== 0) {
          this.currentAnimation.play()
          this.currentAnimationProgress = 0
          this.currentAnimationType = animation
        } else {
          if (this.currentAnimation && animation !== ANIMATION_TYPES.NONE) {
            this.currentAnimation.totalProgress(1)
          }

          this.currentAnimationType = animation

          if (animation === ANIMATION_TYPES.IN) {
            this.currentAnimation = this.inAnimation.restart()
          } else if (animation === ANIMATION_TYPES.IN_REVERSED) {
            this.currentAnimation = this.inReversedAnimation.restart()
          } else if (animation === ANIMATION_TYPES.OUT) {
            this.currentAnimation = this.outAnimation.restart()
          } else if (animation === ANIMATION_TYPES.OUT_REVERSED) {
            this.currentAnimation = this.outReversedAnimation.restart()
          }
        }
      }
    }

    render () {
      return super.render()
    }
  }
}



// WEBPACK FOOTER //
// ./src/templates/app-website/components/SlideHOC.js